import moment from 'moment-timezone'

function buildTimeLabel(startMoment, slotMinutes) {
  const startStr = startMoment.format('hh:mm A')
  const minutes = Number(slotMinutes || 0)

  if (minutes > 0) {
    const endStr = startMoment.clone().add(minutes, 'minutes').format('hh:mm A')
    return `${startStr} - ${endStr}`
  }

  return startStr
}

export function normalizeAvailableSlots(slots = [], timezoneOverride = null) {
  const grouped = {}
  const timezone = timezoneOverride ?? moment.tz.guess()
  const locale = (localStorage.getItem('user_country') === 'BR') ? 'pt-BR' : 'en-AU'

  slots.forEach((slot) => {
    if (!slot?.date) return

    const start = moment.utc(slot.date).tz(timezone)
    const dateOnly = start.format('YYYY-MM-DD')
    const timeLabel = buildTimeLabel(start, slot?.slot_size)
    const weekDay = new Intl.DateTimeFormat(locale, { weekday: 'long', timeZone: timezone }).format(start.toDate())

    if (!grouped[dateOnly]) grouped[dateOnly] = { date: dateOnly, weekDay, times: [] }

    grouped[dateOnly].times.push({
      label: timeLabel,
      value: start.format('hh:mm A'),
      slotSize: Number(slot?.slot_size || 0),
      slot,
    })
  })

  Object.values(grouped).forEach((group) => {
    group.times.sort((a, b) => {
      const aDate = a?.slot?.date ? new Date(a.slot.date).getTime() : 0
      const bDate = b?.slot?.date ? new Date(b.slot.date).getTime() : 0
      return aDate - bDate
    })
  })

  return Object.values(grouped).sort((a, b) => a.date.localeCompare(b.date))
}
